import React from 'react';
import './ComingSoon.css'; // Importa los estilos específicos

const ComingSoon = () => {
  return (
    <div className="coming-soon-container">
      <h1 className="coming-soon-text">Próximamente</h1>
    </div>
  );
};

export default ComingSoon;
